<app-module-layout>
    <router-outlet content></router-outlet>
</app-module-layout>
